import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'User drags either the front or the back of the selected video so they can trim or recover what was trimmed, or splits the selected video into segments',
  name: 'trim_video',
  params: [
    {
      description: 'Whether the user is trimming, extending, or splitting the video',
      name: 'trim_type',
      required: true,
      type: 'enum',
      values: ['trim', 'extend', 'split'],
    },
    {
      description: 'Which end of the video the user is adjusting (not sent for split)',
      name: 'location',
      required: false,
      type: 'enum',
      values: ['front', 'back'],
    },
  ],
};

export default META;
